<div class="ion-padding">

  <h1 [ngStyle]="{'color': b.subtitle_color }"  class="title-button" expand="full" [innerHTML]="b.title"></h1>

</div>